import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const TRACK_SESSION_MAP = new Map<
  string,
  {
    sequence: TrackIDManager['sequence'];
    trackSession: TrackIDManager['trackSession'];
  }
>();

export class TrackIDManager {
  static instance: TrackIDManager;
  public sequence: number = 1;
  private _trackSession!: string;

  constructor(startSequence?: number) {
    if (TrackIDManager.instance instanceof TrackIDManager) {
      console.warn('[TrackIDManager] TrackIDManager is a singleton');
      return TrackIDManager.instance;
    }

    TrackIDManager.instance = this;

    this.reset();
    this.sequence = startSequence ?? 1;
  }

  get trackID(): string {
    const { sequence, _trackSession } = this;

    return `${_trackSession}${String(sequence).padStart(4, '0')}`;
  }

  get trackSession(): string {
    return this._trackSession;
  }

  cleanup() {
    this.sequence = 1;
    this._trackSession = '';

    TRACK_SESSION_MAP.clear();
  }

  next() {
    this.sequence++;
  }

  reset() {
    this.sequence = 1;
    this._trackSession = dayjs().utc().format('YYMMDDHHmmssSSS');
  }

  restore(key: string) {
    const trackSession = TRACK_SESSION_MAP.get(key);

    if (trackSession) {
      this.sequence = trackSession.sequence;
      this._trackSession = trackSession.trackSession;

      return true;
    }

    return false;
  }

  save(key: string) {
    TRACK_SESSION_MAP.set(key, {
      sequence: this.sequence,
      trackSession: this._trackSession,
    });
  }

  static resetInstance() {
    TrackIDManager.instance = undefined as unknown as TrackIDManager;
  }

  static isValidTrackID(trackID?: string) {
    return typeof trackID === 'string' && trackID.length === 19;
  }
}

export const trackIDManager = new TrackIDManager();
